<div class="section-card">
  <div class="section-head">
    <span class="title">
      <i class="bi bi-calendar-x" style="color: var(--clug-warning);"></i>
      Missing Timesheets
      <span class="count">{{ missingTimesheetsCount }}</span>
    </span>
    <a [routerLink]="" (click)="openAllMissingtimesheets()" class="link-primary">
      See all <i class="bi bi-arrow-right"></i>
    </a>
  </div>

  <div class="section-list" *ngIf="missingTimesheets?.length; else emptyMissing">
    <div *ngFor="let missingTimesheet of missingTimesheets; let i = index" class="list-item">
      <div class="avatar" (click)="redirect('/candidates', missingTimesheet.candidate)">
        <img *ngIf="missingTimesheet.profile_pic"
             [src]="dataSharedService.getImage(missingTimesheet.profile_pic)"
             [alt]="missingTimesheet.candidate" />
        <span *ngIf="!missingTimesheet.profile_pic">
          {{ authService.getInitials(missingTimesheet.candidate) }}
        </span>
      </div>

      <div class="meta">
        <a [routerLink]="" (click)="redirect('/candidates', missingTimesheet.candidate)" class="name">
          {{ missingTimesheet.candidate }}
        </a>
        <div class="sub">{{ missingTimesheet.job }} · {{ missingTimesheet.client }}</div>
      </div>

      <div class="right-chips">
        <button type="button" class="icon-btn-sm"
          title="Send reminder"
          (click)="openSendReminderPopUp(missingTimesheet.candidate_uuid, missingTimesheet.candidate_first_name, missingTimesheet.job, missingTimesheet.client)">
          <i class="bi bi-envelope"></i>
        </button>
      </div>
    </div>
  </div>

  <ng-template #emptyMissing>
    <div class="section-empty">
      <div class="ico"><i class="bi bi-calendar-check"></i></div>
      <h4>All caught up</h4>
      <p>No missing timesheets right now.</p>
    </div>
  </ng-template>
</div>
